module.exports = __webpack_public_path__ + "static/media/chart-scatter.9cdefecf.svg";